import { render, staticRenderFns } from "./ParticularsSection.vue?vue&type=template&id=21dc49d3&scoped=true&"
import script from "./ParticularsSection.vue?vue&type=script&lang=js&"
export * from "./ParticularsSection.vue?vue&type=script&lang=js&"
import style0 from "./ParticularsSection.vue?vue&type=style&index=0&id=21dc49d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc49d3",
  null
  
)

export default component.exports